import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  .amex-text {
    margin-bottom: ${spacing(3)};
  }
`
